<div class="acc-tap">
  <h3 class="acc-tap-title">{{ "fundApplication.companyInformationTitle" | translate }}</h3>
  <hr class="m-0" />
  <form style="padding: 25px" [formGroup]="form">
    <div class="p-fluid grid">
      <!-- First row(s): differs when CR status is returned -->
      <ng-container *ngIf="showCrStatus && !hideCrStatus">
        <!-- crNumber -->
        <div class="field col-12 md:col-4">
          <label for="crNumber">{{ "clientInfo.crNumber" | translate }} </label>
          <input
            id="crNumber"
            type="text"
            [class.disabled]="!allowEditAllFields"
            pInputText
            formControlName="crNumber"
            maxlength="10"
            (input)="onCrNumberInput()"
            [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('crNumber') }"
          />
          <small *ngIf="isFieldInvalid('crNumber')" class="p-error">
            {{ getFieldError("crNumber") }}
          </small>
        </div>

        <!-- crStatus -->
        <div class="field col-12 md:col-4">
          <label for="crStatus">{{ "common.cr_status" | translate }}</label>
          <input
            id="crStatus"
            [class.disabled]="!allowEditAllFields"
            type="text"
            pInputText
            formControlName="crStatus"
            [readonly]="!allowEditAllFields"
            [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('crStatus') }"
          />
          <small *ngIf="isFieldInvalid('crStatus')" class="p-error">
            {{ getFieldError("crStatus") }}
          </small>
        </div>

        <!-- unitedNationsNumber -->
        <div class="field col-12 md:col-4">
          <label for="unitedNationsNumber"
            >{{ "clientInfo.UnitedNationsNumber" | translate }}
          </label>
          <input
            id="unitedNationsNumber"
            [class.disabled]="!allowEditAllFields"
            type="text"
            pInputText
            formControlName="unitedNationsNumber"
            maxlength="10"
            (input)="onUnitedNationsNumberInput()"
            [ngClass]="{
              'ng-invalid ng-dirty': isFieldInvalid('unitedNationsNumber')
            }"
          />
          <small *ngIf="isFieldInvalid('unitedNationsNumber')" class="p-error">
            {{ getFieldError("unitedNationsNumber") }}
          </small>
        </div>
      </ng-container>

      <ng-container *ngIf="!showCrStatus || hideCrStatus">
        <!-- crNumber -->
        <div class="field col-12 md:col-6">
          <label for="crNumber">{{ "clientInfo.crNumber" | translate }} </label>
          <input
            id="crNumber"
            type="text"
            [class.disabled]="!allowEditAllFields"
            pInputText
            formControlName="crNumber"
            maxlength="10"
            (input)="onCrNumberInput()"
            [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('crNumber') }"
          />
          <small *ngIf="isFieldInvalid('crNumber')" class="p-error">
            {{ getFieldError("crNumber") }}
          </small>
        </div>

        <!-- unitedNationsNumber -->
        <div class="field col-12 md:col-6">
          <label for="unitedNationsNumber"
            >{{ "clientInfo.UnitedNationsNumber" | translate }}
          </label>
          <input
            id="unitedNationsNumber"
            [class.disabled]="!allowEditAllFields"
            type="text"
            pInputText
            formControlName="unitedNationsNumber"
            maxlength="10"
            (input)="onUnitedNationsNumberInput()"
            [ngClass]="{
              'ng-invalid ng-dirty': isFieldInvalid('unitedNationsNumber')
            }"
          />
          <small *ngIf="isFieldInvalid('unitedNationsNumber')" class="p-error">
            {{ getFieldError("unitedNationsNumber") }}
          </small>
        </div>
      </ng-container>

      <!-- companyName -->
      <div class="field col-12 md:col-4">
        <label for="companyName">{{
          "clientInfo.companyName" | translate
        }}</label>
        <input
          id="companyName"
          [class.disabled]="!allowEditAllFields"
          type="text"
          pInputText
          formControlName="companyName"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('companyName') }"
        />
        <small *ngIf="isFieldInvalid('companyName')" class="p-error">
          {{ getFieldError("companyName") }}
        </small>
      </div>

      <!-- commercialRegistrationExpiryDate -->
      <div class="field col-12 md:col-4">
        <label for="commercialRegistrationExpiryDate"
          >{{ "clientInfo.crExpiryDate" | translate }}
        </label>
        <p-calendar
          id="commercialRegistrationExpiryDate"
          formControlName="commercialRegistrationExpiryDate"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          appendTo="body"
          styleClass="w-full tal-gregorian-datepicker"
          inputStyleClass="form-control"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid(
              'commercialRegistrationExpiryDate'
            )
          }"
        ></p-calendar>
        <small
          *ngIf="isFieldInvalid('commercialRegistrationExpiryDate')"
          class="p-error"
        >
          {{ getFieldError("commercialRegistrationExpiryDate") }}
        </small>
      </div>

      <!-- companyTypeId -->
      <div class="field col-12 md:col-4">
        <label for="companyTypeId"
          >{{ "clientInfo.CompanyTypeId" | translate }}
        </label>
        <p-dropdown
          id="companyTypeId"
          formControlName="companyTypeId"
          [options]="companyTypes"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          [loading]="lookupsLoading"
          appendTo="body"
          [autoDisplayFirst]="false"
          [resetFilterOnHide]="true"
          placeholder="{{ 'common.select' | translate }}"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('companyTypeId') }"
        >
        </p-dropdown>
        <small *ngIf="isFieldInvalid('companyTypeId')" class="p-error">
          {{ getFieldError("companyTypeId") }}
        </small>
      </div>

      <!-- companyActivityId -->
      <div class="field col-12 md:col-4">
        <label for="companyActivityId"
          >{{ "common.business_activity" | translate }}
        </label>
        <small *ngIf="lookupsLoading" class="p-text-secondary mb-1" style="display: block">{{
          "step4.loadingLookups" | translate
        }}</small>
        <p-dropdown
          id="companyActivityId"
          formControlName="companyActivityId"
          [options]="companyActivities"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          [loading]="lookupsLoading"
          [virtualScroll]="true"
          [virtualScrollItemSize]="56"
          scrollHeight="280px"
          appendTo="body"
          panelStyleClass="company-sector-dropdown-panel"
          styleClass="w-full company-sector-dropdown"
          [autoZIndex]="true"
          [baseZIndex]="12000"
          [autoDisplayFirst]="false"
          [resetFilterOnHide]="true"
          placeholder="{{ 'common.select' | translate }}"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('companyActivityId')
          }"
        >
          <ng-template pTemplate="item" let-item>
            <div class="company-activity-item">
              <span class="company-activity-item__primary">{{ activityPrimary(item) }}</span>
              <span class="company-activity-item__secondary" *ngIf="activitySecondary(item)">{{
                activitySecondary(item)
              }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            <div class="company-activity-selected" *ngIf="item">
              <span class="company-activity-selected__primary">{{ activityPrimary(item) }}</span>
              <span class="company-activity-selected__secondary" *ngIf="activitySecondary(item)">{{
                activitySecondary(item)
              }}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <small *ngIf="isFieldInvalid('companyActivityId')" class="p-error">
          {{ getFieldError("companyActivityId") }}
        </small>
      </div>

      <!-- establishmentDate -->
      <div class="field col-12 md:col-4">
        <label for="establishmentDate"
          >{{ "common.establishment_date" | translate }}
          <span class="input-star">*</span></label
        >
        <p-calendar
          id="establishmentDate"
          formControlName="establishmentDate"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="crYearRange"
          appendTo="body"
          styleClass="w-full tal-gregorian-datepicker"
          inputStyleClass="form-control"
          [showButtonBar]="true"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('establishmentDate')
          }"
        ></p-calendar>
        <small *ngIf="isFieldInvalid('establishmentDate')" class="p-error">
          {{ getFieldError("establishmentDate") }}
        </small>
      </div>

      <!-- numberOfEmployees -->
      <div class="field col-12 md:col-4">
        <label for="numberOfEmployees"
          >{{ "clientInfo.numEmployees" | translate }}
          <span class="input-star">*</span></label
        >
        <input
          id="numberOfEmployees"
          type="number"
          pInputText
          formControlName="numberOfEmployees"
          min="1"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('numberOfEmployees')
          }"
        />
        <small *ngIf="isFieldInvalid('numberOfEmployees')" class="p-error">
          {{ getFieldError("numberOfEmployees") }}
        </small>
      </div>

      <!-- vatNumber -->
      <div class="field col-12 md:col-6">
        <label for="vatNumber">{{ "clientInfo.vatNumber" | translate }}</label>
        <input
          id="vatNumber"
          type="text"
          pInputText
          formControlName="vatNumber"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('vatNumber') }"
        />
        <small *ngIf="isFieldInvalid('vatNumber')" class="p-error">
          {{ getFieldError("vatNumber") }}
        </small>
      </div>

      <!-- website -->
      <div class="field col-12 md:col-6">
        <label for="website">{{ "clientInfo.website" | translate }}</label>
        <input
          id="website"
          type="text"
          pInputText
          formControlName="website"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('website') }"
        />
        <small *ngIf="isFieldInvalid('website')" class="p-error">
          {{ getFieldError("website") }}
        </small>
      </div>
    </div>

    <div class="mt-3 text-right" *ngIf="!isDetails">
      <button
        pButton
        type="button"
        label="{{ 'save' | translate }}"
        class="p-button-primary"
        (click)="save()"
      ></button>
    </div>
  </form>
</div>
